module.exports = __webpack_public_path__ + "img/mind-header-nl.c2a27af1.png";